/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
import React, {
 useState, useContext, useEffect, useRef, useMemo 
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import AccountHelpers from '@apps/flows/activation/services/accountHelper'
import {
  PAYMENT_STATE,
  updatePaymentStates,
  referAFriend as referAFriendInitState
} from '@apps/redux/features/PayAndReviewSlice'
import { Input, Chip, Button } from '@telus/koodo-ui-kit'
import Sites from '@sites/index'
import { getById, getBySlug } from '@apps/utils/contentful'
import PaymentChangeHandlers, {
  PAYMENT_EVENTS
} from '@apps/utils/ChangeHandlers/PaymentChangeHandlers'
import { ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { getPromoNames } from '@apps/utils/common'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'


const MultiRafCode = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const {
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region
  } = useContext(ApplicationContext)

  const {
    userType,
    content: { pageContent },
    user: { selectedLanguage }
  } = useSelector((state) => state.common)

  const isDealer = userType === Sites.dealer
  const pagePrefix = isDealer ? 'Dealer' : 'Consumer'
  const pageTextContent = useMemo(() => {
    const paymentPage = getById(pageContent, `paymentPage${pagePrefix}`)?.[language]
    if (!paymentPage) return {}
    const { shortTextFields } = paymentPage
    return {
      friendRefCode: getBySlug(shortTextFields, 'friendRefCode')?.value,
      friendRefCodeText: getBySlug(shortTextFields, 'friendRefCodeText')?.value,
      add: getBySlug(shortTextFields, 'add')?.value,
      enterFriendCode: getBySlug(shortTextFields, 'enterFriendCode')?.value,
      friendRefCodeInvalid: getBySlug(shortTextFields, 'friendRefCodeInvalid')?.value,
      friendRefCodeUsageExceeded: getBySlug(shortTextFields, 'friendRefCodeUsageExceeded')?.value
    }
  }, [pageContent, selectedLanguage])

  const {
    friendRefCode,
    friendRefCodeText,
    add,
    enterFriendCode,
    friendRefCodeInvalid,
    friendRefCodeUsageExceeded
  } = pageTextContent

  const paymentState = useSelector((state) => state.payAndReviewPage)
  const updatePaymentStore = (payload) => {
    dispatch(updatePaymentStates(payload))
  }
 
  const tagManagerInfo = useTagManagerInfo()

  // eslint-disable-next-line camelcase
  const pushClickAnalytics = ({ click_text, promoCodeDescription, event_type, target_link, field_warning, error_response_code, event_click = ANALYTICS_EVENT_TYPES.CLICK } = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text,
        field_warning,
        error_response_code,
        promoCodeDescription
      }, event_type, event_click, target_link)
    )
  }

  const {
    [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE]: friendReferralCode,
    [PAYMENT_STATE.RAF.FRIEND_REFERRAL_SETTINGS]: friendReferralSettings,
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: multiPromotionCodeInfo,
  } = paymentState

  const { isValidReferral } = brandServices

  const [isFriendReferralLoading, setIsFriendReferralLoading] = useState(false)
  const [isValidFriendReferralCode, setIsValidFriendReferralCode] = useState(false)
  const [friendReferralCodeError, setFriendReferralCodeError] = useState('')

  const mounted = useRef(false)
  const addRafCodeButtonRef = useRef(null)

  useEffect(() => {
    if(!mounted.current) {
      mounted.current = true
      return
    }

    if (!friendReferralCodeError) return
    validateVoucherCodeOnLanguageChange()
  }, [language])

  const validateFriendCode = (value) => {
    if (!value) setFriendReferralCodeError(enterFriendCode)
    else setFriendReferralCodeError('')
  }

  const addFriendReferralCode = async () => {
    if (addRafCodeButtonRef.current) {
      addRafCodeButtonRef.current.blur()
    }
    validateFriendCode(friendReferralCode)
    if (friendReferralCode) {
      pushClickAnalytics(friendRefCode)
      setIsFriendReferralLoading(true)
      const { referral, error } =
        (await AccountHelpers.applyReferralCode(
          isValidReferral,
          friendReferralCode,
          friendReferralSettings
        )) || {}
      if (referral) {
        pushClickAnalytics({ click_text: friendRefCode, promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'referal code added successfully' })
        setIsValidFriendReferralCode(true)
        updatePaymentStore({
          ...paymentState,
          [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE]: friendReferralCode,
          [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_INFO]: referral,
          [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_IS_VALID]: true
        })
        setIsFriendReferralLoading(false)
      } else {
        const { code: errorCode } = error || {}
        const errorMessage = errorCode !== '429' ? friendRefCodeInvalid : friendRefCodeUsageExceeded
        pushClickAnalytics({ field_warning: errorMessage, error_response_code: errorCode, promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'error while applying raf code' })
        setIsValidFriendReferralCode(false)
        setFriendReferralCodeError(errorMessage)
        updatePaymentStore({
          ...paymentState,
          [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_IS_VALID]: false
        })
        setIsFriendReferralLoading(false)
      }
    }
  }
  /* istanbul ignore next */
  const validateVoucherCodeOnLanguageChange = async () => {
    validateFriendCode(friendReferralCode)
    if (friendReferralCode) {
      const { referral, error } =
        (await AccountHelpers.applyReferralCode(
          isValidReferral,
          friendReferralCode,
          friendReferralSettings
        )) || {}
      if (referral) {
        setIsFriendReferralLoading(false)
      } else {
        const { code: errorCode } = error || {}
        const errorMessage = errorCode !== '429' ? friendRefCodeInvalid : friendRefCodeUsageExceeded
        setIsValidFriendReferralCode(false)
        setFriendReferralCodeError(errorMessage)
        updatePaymentStore({
          ...paymentState,
          [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_IS_VALID]: false
        })
        setIsFriendReferralLoading(false)
      }
    }
  }


  const removeFriendReferralCode = () => {
    pushClickAnalytics({ click_text: 'remove referral code', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'close icon - remove referral code' })
    setIsValidFriendReferralCode(false)
    updatePaymentStore({
      ...paymentState,
      ...referAFriendInitState,
      [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_IS_VALID]: false
    })
  }

  const getAddButtonTokens = (state) => {
    return state.inactive ? {} : { backgroundColor: '#000000', color: '#ffffff', borderColor: '#000000' }
  }
  
  return (
    <div className="w-full space-y-4">
      <div className="flex flex-col items-start space-x-0 space-y-4 lg:space-y-0 md:space-y-0 md:space-x-4 lg:space-x-4 md:flex-row lg:flex-row">
        <div className="flex flex-col flex-1 w-full space-y-4">
          <div className="flex flex-col flex-1">
            <div className="flex flex-row w-full">
              <div className="flex flex-col flex-1">
                  <div className="flex flex-col md:flex-row w-full items-start flex-1 gap-4 md:gap-6">
                  <div className="flex flex-col flex-1 w-full">
                    <Input
                      label={friendRefCode}
                      hint={friendRefCodeText}
                      id="friendReferralCode"
                      value={isValidFriendReferralCode ? '' : friendReferralCode}
                      onChange={(value) => {
                        PaymentChangeHandlers[PAYMENT_EVENTS.VALIDATE_CODE].onChange(
                          value,
                          validateFriendCode,
                          PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE,
                          updatePaymentStore
                        )
                      }}
                      onFocus={() => setFriendReferralCodeError('')}
                      feedback={friendReferralCodeError}
                      validation={friendReferralCodeError ? 'error' : undefined}
                      maxLength={7}
                      disabled={isValidFriendReferralCode}
                      testId="payment-referralInput"
                    />
                    
                  </div>
                  <div className="w-full sm:w-auto sm:self-end flex flex-col">
                    <Button
                      ref={addRafCodeButtonRef}
                      onPress={addFriendReferralCode}
                      inactive={isValidFriendReferralCode || isFriendReferralLoading}
                      disabled={isValidFriendReferralCode}
                      loading={isFriendReferralLoading}
                      variant={{ width: 'full' }}
                      tokens={(state) => getAddButtonTokens(state)}
                      testId="payment-rafButton"
                    >
                      {add}
                    </Button>
                    {friendReferralCodeError && <div className="h-12" aria-hidden="true" />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {isValidFriendReferralCode && (
          <div className="mt-2 flex flex-wrap">
            <Chip
              label={friendReferralCode}
              onDismiss={removeFriendReferralCode}
              dismissLabel="Remove referral code"
              testId="payment-remove-raf"
            />
          </div>
        )}
      </div>
    </div>
  )
}
export default MultiRafCode
